// Dependencies
import axios from "axios";
import Cookies from "js-cookie";

// Project
import { getApiDomain } from "../Utils/getDomain";

export const client = axios.create({
	baseURL: `${getApiDomain()}`,
	headers: {
		"Content-Type": "application/json",
		Authorization: Cookies.get("logan-auth-token"),
	},
	withCredentials: true,
});

/**
 * Since axios does not support streaming, we need to use the native fetch API to stream data.
 */
export const fetchStream = (params) => {
	const { url, data, method } = params;

	const fetchMethod = method || (data ? "POST" : "GET");
	const fetchOptions = {
		method: fetchMethod,
		headers: {
			Accept: "application/json, text/plain, */*",
			Authorization: Cookies.get("logan-auth-token"),
			"Content-Type": "application/json",
		},
		credentials: "include",
	};

	if (fetchMethod === "POST" && data) {
		fetchOptions.body = JSON.stringify(data);
	}

	return fetch(`${getApiDomain()}${url}`, fetchOptions);
};

/**
 *
 * @param {Object} config
 * @param {string} config.url - The URL to connect to the AI stream.
 * @param {'GET' | 'POST' | 'PUT' | 'DELETE'} [config.method] - The method to use for the request.
 * @param {any} [config.data] - The data to send with the request.
 * @param {any} [config.params] - The parameters to send with the request.
 * @param {boolean} [config.isStream] - Whether the request is a stream.
 * @returns
 */
const request = async (config) => {
	try {
		const req = await client.request({
			url: config.url,
			method: config.method || "GET",
			...(config.data ? { data: config.data } : {}),
			...(config.params ? { params: config.params } : {}),
			headers: {
				...client.defaults.headers,
				Authorization: Cookies.get("logan-auth-token"),
				...(config.headers ? config.headers : {}),
			},
		});

		return req;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error;
		}

		return {
			data: null,
			...error,
		};
	}
};

export default request;
